import {
    AlignSetting,
    BackgroundType,
    calcHeaderHeight,
    getColor,
    HeaderBackgroundType,
    HeaderTitlePosition,
    SubstrateType,
} from '@webapp/common/lib/ui';

export interface SurveyAddonBrand {
    background: BackgroundType;
    backgroundColor: string;
    backgroundGradient: string;
    backgroundImage: string;
    backgroundVideo?: string;
    backgroundTransparent: number;
    headerAllPage: boolean;
    headerBackgroundColor: string;
    headerBackgroundImage: string;
    headerSize: number;
    headerStick: boolean;
    headerTitleAlign: AlignSetting;
    headerTitlePosition: HeaderTitlePosition;
    headerType: HeaderBackgroundType;
    logo: string;
    logoPos: string;
    logoStyle: string;
    mobileLogoStyle?: string;
    substrate: string;
    titleStyle: string;
    mobileTitleStyle?: string;
}

export const initialSurveyAddonBrand: Readonly<SurveyAddonBrand> = {
    background: BackgroundType.COLOR,
    backgroundColor: getColor('white'),
    backgroundGradient: getColor('white'),
    backgroundImage: null,
    backgroundTransparent: 100,
    headerAllPage: true,
    headerBackgroundColor: 'transparent',
    headerBackgroundImage: null,
    headerSize: 50,
    headerStick: false,
    headerTitleAlign: AlignSetting.CENTER,
    headerTitlePosition: HeaderTitlePosition.IN_HEAD,
    headerType: HeaderBackgroundType.TRANSPARENT,
    logo: null,
    logoPos: '',
    logoStyle: '',
    mobileLogoStyle: 'top: 0; right: 25%; width: 50%;',
    substrate: SubstrateType.EVERY_QUESTION,
    // 230 * 0.5 + 40 = 155
    // 155 - 75 = 80
    // 80 * 100 / 155 = 25.8065 %
    titleStyle:
        'width: 50%; right: 25%; top: 0; display: flex; align-items: center; ' + `height: ${calcHeaderHeight(50)}px;`,
    mobileTitleStyle:
        'width: 100%; right: 0; top: 0; display: flex; align-items: center; ' + `height: ${calcHeaderHeight(50)}px;`,
};
